import { Skeleton } from 'components/common/skeleton';
import './CartItemSide.css';

const SkeletonCartItemSide = () => {
    return (
        <div className={`ab-cart-side-wrapper`}>
            <div className="ab-cart-side-upper">
                <div className="ab-cart-side-img">
                    <Skeleton width={110} height={120} />
                </div>
                <div className="ab-cart-side-general">
                    <div style={{ marginBottom: '5px' }}>
                        <Skeleton width={'100%'} height={25} />
                    </div>
                    <span>
                        {' '}
                        <Skeleton width={'100%'} height={20} />
                    </span>
                    <span className="ab-cart-side-property-name">
                        <Skeleton width={'100%'} height={20} />
                    </span>
                </div>
            </div>
            <div className={`sidebar_room open`}>
                <div className="sidebar_room_trigger">
                    <Skeleton width={'100%'} height={18} />

                    <div className="sidebar-room-trash">
                        <div
                            className=""
                            style={{
                                margin: '0',
                                cursor: 'pointer',
                                height: '32px',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <span style={{ marginRight: '5px' }}>
                                <Skeleton width={'100%'} height={18} />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="sidebar_room_hidden" id="room_hidden_2825">
                    <div className="sidebar_info_detail_rows">
                        <div className="sidebar_info_detail_row justify-between flex">
                            <div className="sidebar_info_detail_row_title flex column justify-center">
                                <Skeleton width={'100%'} height={13} />
                            </div>
                            <div className="sidebar_info_detail_row_detail">
                                <Skeleton width={'100%'} height={40} />
                            </div>
                        </div>
                        <hr
                            style={{
                                display: 'inline-block',
                                width: '100%',
                                marginTop: '0px',
                                border: 'solid 1px #d1d6db',
                                marginBottom: '0',
                            }}
                        />
                        <div className="sidebar_info_detail_row justify-between flex">
                            <div className="sidebar_info_detail_row_title flex column justify-center">
                                <Skeleton width={'100%'} height={13} />
                            </div>
                            <div className="sidebar_info_detail_row_detail">
                                <Skeleton width={'100%'} height={40} />
                            </div>
                        </div>
                        <hr
                            style={{
                                display: 'inline-block',
                                width: '100%',
                                border: 'solid 1px #d1d6db',
                                marginBottom: '3px',
                                marginTop: '10px',
                            }}
                        />
                    </div>
                    <div
                        className="sidebar_room_hidden_info_row"
                        style={{ fontWeight: 700 }}
                    >
                        <div className="sidebar_room_hidden_info_title flex column">
                            <span className="leftnote">
                                <Skeleton width={'100%'} height={20} />
                            </span>
                        </div>
                        <div className="sidebar_room_hidden_info_title flex column">
                            <span className="leftnote">
                                <Skeleton width={'100%'} height={20} />
                            </span>
                        </div>
                    </div>
                    <div className="sidebar_room_hidden_info_row">
                        <div className="sidebar_room_hidden_info_title flex column">
                            <span className="leftnote">
                                <Skeleton width={'100%'} height={20} />
                            </span>
                        </div>
                        <div style={{ paddingLeft: '3px' }}>
                            <div className="sidebar_room_hidden_info_row">
                                <div className="sidebar_room_hidden_info_title flex column">
                                    <span className="leftnote">
                                        <Skeleton width={'100%'} height={20} />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sidebar_room_hidden_info_row">
                        <div className="sidebar_room_hidden_info_detail">
                            <span className="leftnote">
                                <Skeleton width={'100%'} height={20} />
                            </span>
                        </div>
                    </div>
                    <div
                        className="sidebar_room_hidden_info_edit"
                        style={{
                            borderTop: 'solid 2px #d1d6db',
                            marginTop: '5px',
                            paddingTop: '5px',
                        }}
                    >
                        <div
                            className="sidebar_room_hidden_info_detail"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                textAlign: 'left',
                            }}
                        >
                            <Skeleton width={'100%'} height={20} />
                        </div>
                    </div>
                    <div
                        className="sidebar_room_hidden_info_row"
                        style={{ flexDirection: 'column' }}
                    >
                        <div className="sidebar_extra_row">
                            <Skeleton width={'100%'} height={40} />
                        </div>
                    </div>
                    <div
                        className="sidebar_room_hidden_info_row"
                        style={{
                            borderTop: 'solid 2px #d1d6db',
                            marginTop: '5px',
                            paddingTop: '5px',
                        }}
                    >
                        <div
                            className="sidebar_room_hidden_info_detail"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                                textAlign: 'left',
                            }}
                        >
                            <Skeleton width={'100%'} height={20} />

                            <Skeleton width={'100%'} height={20} />
                        </div>
                    </div>
                    <div className="">
                        <Skeleton width={'100%'} height={20} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonCartItemSide;
